module.exports = __webpack_public_path__ + "img/ditbenik4.06771c32.jpg";